import { ButtonColorKey, type ButtonProps, ButtonVariant } from '@/interfaces';
import ArrowDown from 'public/images/icons/arrow_down.svg';
import type React from 'react';
import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import Button from './Button';

const Arrow = styled(ArrowDown)``;

const StyledButton = styled(Button)<{ $collapsed: boolean }>`
  padding: ${({ theme }) => theme.spacing[8]} 0;

  :not([disabled]):hover {
    text-decoration: initial;
  }

  ${({ $collapsed }) =>
    !$collapsed &&
    css`
      ${Arrow} {
        transform: rotate(180deg);
      }
    `}
`;

interface ViewMoreButtonProps {
  collapsed: boolean;
  /** Translated label for the current state; defaults to "View More" / "View Less". */
  label?: string;
}
const ViewMoreButton: React.FC<
  // biome-ignore lint/suspicious/noExplicitAny: button HTML attributes type varies by element
  ButtonProps & ViewMoreButtonProps & (AnchorHTMLAttributes<'a'> | ButtonHTMLAttributes<any>)
> = ({ collapsed, label, ...props }) => {
  return (
    <StyledButton
      {...props}
      variant={ButtonVariant.Link}
      color={ButtonColorKey.Blue}
      icon={Arrow}
      $collapsed={collapsed}
    >
      {label ?? (collapsed ? 'View More' : 'View Less')}
    </StyledButton>
  );
};

export default ViewMoreButton;
